import { useSegmentTrack } from "@/hooks/use-segment";
import { useEditorURL, } from "@/queries/editor-queries";
import { type PlainMessage } from "@bufbuild/protobuf";
import { type Environment } from "gitpod-next-api/gitpod/v1/environment_pb";
import { useCallback } from "react";

export function useOpenEditor() {
    const editorURL = useEditorURL();
    const segmentTrack = useSegmentTrack();

    return useCallback(async (editorId: string, environment?: Environment | PlainMessage<Environment>) => {
        try {
            const result = await editorURL.mutateAsync({ editorId, environment });
            const url = result.url;
            if (!url) {
                return;
            }

            const redirect = !/^https?:\/\//.test(url);
            // redirect only if points to desktop application
            // don't navigate browser to another page
            segmentTrack("Open Editor", { redirect });
            if (redirect) {
                window.location.href = url;
            } else {
                window.open(url, "_blank", "noopener");
            }
        } catch (e) {
            console.error(e);
        }
    }, [editorURL, segmentTrack]);
}
